import React, { Component } from "react";
import { Col, Row } from "react-flexbox-grid";
import { DoughnutChart, Loader } from "ui-kit-ck-consultant";

import axiosConfig from "../../../utils/axiosConfig";
import AuthContext from "../../../context/AuthContext";
import WidgetWrapper from "./WidgetWrapper";

export default class WidgetInterviewProgress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: true,
      nbInterview: 0,
      nbSIM: 0,
    };
  }

  static contextType = AuthContext;

  componentDidMount() {
    let loaded = 0;
    const checkLoaded = () => {
      loaded++;
      if (loaded >= 2) this.setState({ isLoad: false });
    };

    axiosConfig("home/count-interview").then((res) => {
      if (res.data.success) this.setState({ nbInterview: res.data.data });
      checkLoaded();
    });

    axiosConfig("home/count-sim").then((res) => {
      if (res.data.success) this.setState({ nbSIM: res.data.data });
      checkLoaded();
    });
  }

  render() {
    const { isLoad, nbInterview, nbSIM } = this.state;
    const role = Number(this.context.role);

    const title =
      role >= 1
        ? "Progression entretiens & SIM (équipe)"
        : "Progression entretiens & SIM";

    return (
      <WidgetWrapper
        title={title}
        isCustomizing={this.props.isCustomizing}
        dragHandleProps={this.props.dragHandleProps}
        onHide={this.props.onHide}
      >
        {isLoad ? (
          <Loader />
        ) : (
          <Row>
            <Col xs={12} md={6}>
              <DoughnutChart
                className="mt-10 mb-10"
                number={nbInterview}
                text="Entretiens non clos"
                max={Math.max(nbInterview, 1)}
                color={nbInterview === 0 ? "#0c8540" : "#f2711c"}
              />
            </Col>
            <Col xs={12} md={6}>
              <DoughnutChart
                className="mt-10 mb-10"
                number={nbSIM}
                text="SIM non clos"
                max={Math.max(nbSIM, 1)}
                color={nbSIM === 0 ? "#0c8540" : "#f2711c"}
              />
            </Col>
          </Row>
        )}
      </WidgetWrapper>
    );
  }
}
